import { IComponent, ICustomEventData } from '@modules/src/interfaces/IComponents'
import { AssetType } from '@modules/src/enums/AssetType'
import GameSignals from '../../signals/GameSignals'
import { ComponentEvent } from '@modules/src/enums/ComponentEvent'
import { SpineAnimation } from '@base/spineAnimation/SpineAnimation'
import { Orientation } from '@modules/src/enums/Orientation'
import Facade from '../../Facade'
import { ContainersNames } from '@/containers/ContainersNames'
import { startLogoAnimation } from '@/managers/ui/LogoManager'
export const LOGO_COMPONENT: IComponent = {
    name: ContainersNames.LOGO_CONTAINER,
    type: AssetType.CONTAINER,
    position: [
        {
            orientation: Orientation.LANDSCAPE,
            x: 115,
            y: -32.5,
        },
        {
            orientation: Orientation.PORTRAIT,
            x: 0,
            y: 84,
        },
    ],
    items: [
        {
            name: 'Logo',
            type: AssetType.SPINE,
            visible: false,
            src: 'logoAnimation',
            animationSettings: {
                default: {
                    triggerGameSignals: [],
                    animNames: ['EN'],
                    loops: [true],
                    track: 0,
                    timeScales: [1],
                },
            },
            events: [
                {
                    onGameSignalsTriggered: [GameSignals.completeSplashScreenState],
                    event: ComponentEvent.CUSTOM_NEW,
                    callback: function (data: ICustomEventData) {
                        const container: SpineAnimation = data.component.componentElement
                        container.visible = data.signalData
                        if (container.visible) {
                            startLogoAnimation(container)
                        }
                    },
                },
                {
                    onGameSignalsTriggered: [GameSignals.startSpin],
                    event: ComponentEvent.CUSTOM_NEW,
                    callback: function (data: ICustomEventData) {
                        const container: SpineAnimation = data.component.componentElement
                        if (Facade.model.roundState.isFreeSpins) {
                            return
                        }
                        startLogoAnimation(container)
                    },
                },
            ],
            position: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 190,
                    y: 146,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 531.5,
                    y: 83.5,
                },
            ],
            scale: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 1,
                    y: 1,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 1.2,
                    y: 1.2,
                },
            ],
        },
        // {
        //     name: 'Logo Shine',
        //     type: AssetType.SPINE,
        //     visible: false,
        //     src: 'logoAnimation',
        //     animationSettings: {
        //         default: {
        //             triggerGameSignals: [],
        //             animNames: ['anim-logo-play'],
        //             loops: [false],
        //             track: 1,
        //             timeScales: [1],
        //         },
        //     },
        //     events: [
        //         {
        //             onGameSignalsTriggered: [GameSignals.idle],
        //             event: ComponentEvent.CUSTOM_NEW,
        //             callback: function (data: ICustomEventData) {
        //                 const container: SpineAnimation = data.component.componentElement
        //                 const delay: number = 30
        //                 if (Facade.model.roundState.isFreeSpins) {
        //                     return
        //                 }
        //                 gsap.killTweensOf(container)
        //                 gsap.to(container, {
        //                     duration: delay,
        //                     onComplete: () => {
        //                         container.visible = true
        //                         container.start(['anim-logo-idle'], [false], 1, [1])
        //                         //@ts-ignore
        //                         // container.intervalId = setInterval(() => {
        //                         //     container.visible = true
        //                         //     container.start(['shine'], [false], 1, [1])
        //                         // }, 15000)
        //                     },
        //                 })
        //             },
        //         },
        //         {
        //             onGameSignalsTriggered: [GameSignals.startSpin],
        //             event: ComponentEvent.CUSTOM_NEW,
        //             callback: function (data: ICustomEventData) {
        //                 const container: SpineAnimation = data.component.componentElement
        //                 if (Facade.model.roundState.isFreeSpins) {
        //                     return
        //                 }
        //                 gsap.killTweensOf(container)
        //                 gsap.to(container, {
        //                     duration: 0.5,
        //                     alpha: 0,
        //                     onComplete: () => {
        //                         //@ts-ignore
        //                         clearInterval(container.intervalId)
        //                         container.animation.state.setEmptyAnimation(1, 0.2)
        //                         container.animation.state.addAnimation(1, 'anim-logo-play', true, 0)
        //                         container.animation.state.addEmptyAnimation(1, 0.2, 0)
        //                         container.visible = false
        //                         container.alpha = 1
        //                     },
        //                 })
        //             },
        //         },
        //     ],
        //     position: [
        //         {
        //             orientation: Orientation.LANDSCAPE,
        //             x: 190,
        //             y: 146,
        //         },
        //         {
        //             orientation: Orientation.PORTRAIT,
        //             x: 704,
        //             y: 140,
        //         },
        //     ],
        // },
    ],
}
